import {
  FETCH_RECORDS,
  FETCH_RECORDS_SUCCESS,
  FETCH_RECORDS_FAIL,
  WAIT,
  WAIT_SUCCESS,
  WAIT_FAIL
} from "./types";
import {
  delRequest,
  getRequest,
  postRequest,
  putRequest
} from "../../../core/network";
import endpoints from "../../../constants/endPoints.json";
import { notification } from "antd";
import download from "downloadjs";

export const getStore = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.store)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getDashboard = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.dashboard)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getVendorDashboard = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.vendorDashboard)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
        style: { marginTop: "10vh" }
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getProducts = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.products)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const downloadInboundsQRS = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, { responseType: "arraybuffer" }, undefined, token, endpoints.imsAdmin.inbounds.print)
    .then((response) => {
      download(response.data, response.headers["filename"], "application/pdf")
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const downloadStockQRS = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  getRequest({ ...data, responseType: "arraybuffer" }, undefined, token, endpoints.imsAdmin.stocksDownload)
    .then((response) => {
      download(response.data, response.headers["filename"], "application/pdf")
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const downloadProductsQRS = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, { responseType: "arraybuffer" }, undefined, token, endpoints.imsAdmin.productsDownload)
    .then((response) => {
      download(response.data, response.headers["filename"], "application/pdf")
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const addProducts = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.imsAdmin.products)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/ims/admin/products");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const editProducts = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsAdmin.products)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deleteProducts = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.imsAdmin.products)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addOutbound = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  notification.info({ message: "Creating Outbound...", })
  postRequest(data, undefined, undefined, token, endpoints.imsAdmin.inbounds.outbounds)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message,

      });
      dispatch({
        type: WAIT_SUCCESS
      });
      if (navigate && data?.taskId) {
        navigate(`/ims/admin/item-updates/${data.taskId}`);
      } else if (navigate && data?.outbound?._id) {
        navigate(`/ims/admin/outbounds/success/${data.outbound._id}`, { state: { outbound: data.outbound } });
      } else if (navigate) {
        navigate("/ims/admin");
      }
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getOutbound = (outboundId) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(undefined, `/${outboundId}`, token, endpoints.imsAdmin.inbounds.outbounds)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const downloadOutboundReceipt = (outboundId) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  getRequest({ responseType: "arraybuffer" }, `/${outboundId}/pdf`, token, endpoints.imsAdmin.inbounds.outbounds)
    .then((response) => {
      download(response.data, response.headers["filename"], "application/pdf");
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const receiveInbound = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsAdmin.inbounds.items)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message,

      });
      dispatch({
        type: WAIT_SUCCESS
      });
      if (navigate && data?.taskId) {
        navigate(`/ims/admin/item-updates/${data.taskId}`);
      } else {
        navigate && navigate("/ims/admin/inbounds")
      }
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getInbounds = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.inbounds.root)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getInboundItems = (inboundId) => (dispatch, useState) => {
  const token = useState().auth?.token;
  return getRequest({ inboundId }, undefined, token, endpoints.imsAdmin.inbounds.root)
    .then((response) => response.data.inboundItems || [])
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message || "Failed to load inbound items" });
      throw err;
    });
};

export const getItemUpdateTask = (taskId) => (dispatch, useState) => {
  const token = useState().auth?.token;
  return getRequest(undefined, `/${taskId}`, token, endpoints.imsAdmin.itemUpdates)
    .then((response) => response.data.task);
};

export const getItemUpdateTasks = (data) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;
  return getRequest(data, undefined, token, endpoints.imsAdmin.itemUpdates)
    .then((response) => {
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: { itemUpdateTasks: response.data.itemUpdates },
      });
      return response.data.itemUpdates;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: FETCH_RECORDS_FAIL });
      throw err;
    });
};

const downloadNamedPdf = (path, query) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  return getRequest({ ...query, responseType: "arraybuffer" }, undefined, token, path)
    .then((response) => {
      download(response.data, response.headers["filename"] || "document.pdf", "application/pdf");
      dispatch({ type: WAIT_SUCCESS });
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message || "Download failed" });
      dispatch({ type: WAIT_FAIL });
    });
};

export const downloadInboundChecklist = (prRef) => downloadNamedPdf(endpoints.imsAdmin.inbounds.checklist, { prRef });

export const downloadInboundReceipt = ({ prRef, inboundId }) => downloadNamedPdf(
  endpoints.imsAdmin.inbounds.receipt,
  prRef ? { prRef } : { inboundId }
);

export const downloadStockRecountReceipt = (taskId) => downloadNamedPdf(
  `${endpoints.imsAdmin.stockRecount.root}/${taskId}/receipt`
);

export const groupInboundPrRef = (data, onDone) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  return putRequest(data, undefined, undefined, token, endpoints.imsAdmin.inbounds.prRef)
    .then((response) => {
      notification.success({ message: response?.data?.message || "Purchase Request set" });
      dispatch({ type: WAIT_SUCCESS });
      if (typeof onDone === "function") onDone(true);
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: WAIT_FAIL });
      if (typeof onDone === "function") onDone(false);
    });
};

export const deleteInbound = (data, onDone) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.imsAdmin.inbounds.delete)
    .then((response) => {
      notification.success({
        message: response?.data?.message || "Inbound Deleted",
      });
      dispatch({ type: WAIT_SUCCESS });
      if (typeof onDone === "function") onDone(true);
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      dispatch({ type: WAIT_FAIL });
      if (typeof onDone === "function") onDone(false);
    });
};

export const getTickets = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.tickets)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getWarehouses = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.warehouses)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addWarehouses = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.imsAdmin.warehouses)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/ims/admin/warehouses");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const editWarehouses = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsAdmin.warehouses)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deleteWarehouses = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.imsAdmin.warehouses)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getLocations = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.locations)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addLocations = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.imsAdmin.locations)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/ims/admin/warehouses");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const editLocations = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsAdmin.locations)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deleteLocations = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.imsAdmin.locations)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getStocks = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.stocks)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addStocks = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.imsAdmin.stocks)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const editStocks = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsAdmin.stocks)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deleteStocks = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.imsAdmin.stocks)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.orders)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.imsAdmin.orders)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/ims/admin/orders");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const editOrders = (data, setAction, action) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsAdmin.orders)
    .then((response) => {
      const { data } = response;
      setAction && setAction(!action)
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const recreateOrder = (data, setAction, action) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.recreateOrders)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message,

      });
      setAction && setAction(!action)
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const resetOrder = (data, setAction, action) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.resetOrders)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message,

      });
      setAction && setAction(!action)
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const silentCancelOrder = (data, onComplete) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.silentCancelOrder)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message,

      });
      if (typeof onComplete === "function") {
        onComplete(true);
      }
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      if (typeof onComplete === "function") {
        onComplete(false);
      }
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const setItemSoldOut = (data, setAction, action) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsAdmin.soldOutOrders)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data.message,

      })
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const setOrderReturnedToChainz = (data, setAction, action) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsAdmin.returnedToChainzOrders)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data.message,

      })
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const deleteOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.imsAdmin.orders)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getEmployees = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.employees)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addEmployees = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.imsAdmin.employees)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/ims/admin/employees");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const editEmployees = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsAdmin.employees)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deleteEmployees = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.imsAdmin.employees)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getShippingServices = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.shippingServices)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addShippingServices = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.imsAdmin.shippingServices)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: WAIT_SUCCESS
      });
      navigate && navigate("/ims/admin/shipping-services");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getFincartDefaultPickupLocation = (key) => (dispatch, useState) => {
  const token = useState().auth?.token;

  return postRequest({ key }, undefined, undefined, token, endpoints.imsAdmin.fincartDefaultPickupLocation)
    .then((response) => response.data)
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message || "Failed to fetch Fincart default pickup location",
      });
      throw err;
    });
};

export const deleteShippingServices = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.imsAdmin.shippingServices)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data.message,

      })
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getVendors = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.vendors)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addVendors = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.imsAdmin.vendors)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/ims/admin/brands");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const editVendors = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  return putRequest(data, undefined, undefined, token, endpoints.imsAdmin.vendors)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data.message,
      });
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: { vendor: data.newVendor }
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deleteVendors = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.imsAdmin.vendors)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const softDeleteVendors = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.imsAdmin.softDeleteVendors)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data.message,

      })
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getPartners = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.partners)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addPartners = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.imsAdmin.partners)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/ims/admin/brands");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const editPartners = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsAdmin.partners)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deletePartners = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.imsAdmin.partners)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const relinkShopify = (data, navigate) => (dispatch, useState) => {
  const token = useState().auth?.token;

  notification.info({
    message: "Relinking may take minutes",
    description: "You can safely navigate away from this page",

  })
  getRequest(data, undefined, token, endpoints.imsAdmin.relink);
};

export const resyncBosta = (data, navigate) => (dispatch, useState) => {
  const token = useState().auth?.token;

  notification.info({
    message: "Resyncing may take minutes",
    description: "You can safely navigate away from this page",

  })
  getRequest(data, undefined, token, endpoints.imsAdmin.resyncBosta);
};

export const pullFincartStatuses = (data, navigate) => (dispatch, useState) => {
  const token = useState().auth?.token;

  return getRequest(data, undefined, token, endpoints.imsAdmin.pullFincartStatuses)
    .then((response) => {
      const { data: responseData } = response;
      notification.success({
        message: responseData?.message,
      });
      return response;
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      throw err;
    });
};

export const syncUnfulfilledOrders = (data, navigate) => (dispatch, useState) => {
  const token = useState().auth?.token;

  notification.info({
    message: "Pulling unfulfilled orders may take minutes",
    description: "You can safely navigate away from this page",

  })
  getRequest(data, undefined, token, endpoints.imsAdmin.syncUnfulfilledOrders)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message,

      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
    });
};

export const getNoShippingOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.actionCenter.noShipping)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getLateFulfillmentOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.actionCenter.lateFulfillment)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getLateDeliveryOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.actionCenter.lateDelivery)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getLateReturnsOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.actionCenter.lateReturns)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getLatePickupOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.actionCenter.latePickup)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getNotifications = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.notifications)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addNotifications = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.imsAdmin.notifications)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message,

      });
      navigate && navigate("/ims/admin/notifications");
      return dispatch({ type: WAIT_SUCCESS });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getOrderForRTO = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.inboundsRTO)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addInboundRTO = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.imsAdmin.inboundsRTO)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message
      });
      navigate && navigate("/ims/admin/inbounds");
      return dispatch({ type: WAIT_SUCCESS });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getOrderForRTOAction = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsAdmin.inboundsRTO)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,

      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const actionRTOInbound = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsAdmin.inboundsRTO)
    .then((response) => {
      const { data: responseData } = response;
      notification.success({
        message: responseData?.message || "RTO received successfully"
      });

      // Refresh product stock so quantity updates for received (incl. not-on-AWB) SKUs are visible
      const vendorId = data?.vendorId;
      if (vendorId) {
        getRequest({ vendorId, page: 1, limit: 100 }, undefined, token, endpoints.imsAdmin.products)
          .then((productsResponse) => {
            dispatch({
              type: FETCH_RECORDS_SUCCESS,
              payload: productsResponse.data
            });
          })
          .catch(() => {
            // Non-blocking: receive already succeeded
          });
      }

      navigate && navigate("/ims/admin/inbounds");
      return dispatch({ type: WAIT_SUCCESS });
    })
    .catch((err) => {
      notification.error({
        message:
          err?.response?.data?.message ||
          err?.message ||
          "Failed to receive RTO. Please try again."
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getBazaars = (data) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;
  getRequest(data, undefined, token, endpoints.imsAdmin.bazaars)
    .then((response) => dispatch({ type: FETCH_RECORDS_SUCCESS, payload: response.data }))
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: FETCH_RECORDS_FAIL });
    });
};

export const getBazaar = (id) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;
  getRequest(undefined, `/${id}`, token, endpoints.imsAdmin.bazaars)
    .then((response) => dispatch({ type: FETCH_RECORDS_SUCCESS, payload: response.data }))
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: FETCH_RECORDS_FAIL });
    });
};

export const acceptBazaar = (id, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  postRequest({}, undefined, `/${id}/accept`, token, endpoints.imsAdmin.bazaars)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS });
      notification.success({ message: response.data.message });
      return getRequest(undefined, `/${id}`, token, endpoints.imsAdmin.bazaars);
    })
    .then((response) => {
      dispatch({ type: FETCH_RECORDS_SUCCESS, payload: response.data });
      navigate && navigate(`/ims/admin/bazaars/${id}`);
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: WAIT_FAIL });
    });
};

export const fulfillBazaarOutbound = (id) => (dispatch, useState) => {
  const token = useState().auth?.token;
  return postRequest({}, undefined, `/${id}/fulfill-outbound`, token, endpoints.imsAdmin.bazaars)
    .then((response) => response.data)
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      throw err;
    });
};

export const rejectBazaar = (id, reason) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  return postRequest({ reason }, undefined, `/${id}/reject`, token, endpoints.imsAdmin.bazaars)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS });
      notification.success({ message: response.data.message });
      return getRequest(undefined, `/${id}`, token, endpoints.imsAdmin.bazaars);
    })
    .then((response) => {
      dispatch({ type: FETCH_RECORDS_SUCCESS, payload: response.data });
      return response.data;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: WAIT_FAIL });
      throw err;
    });
};

export const downloadBazaarCountSheet = (id) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  return getRequest({ responseType: 'arraybuffer' }, `/${id}/count-sheet/pdf`, token, endpoints.imsAdmin.bazaars)
    .then((response) => {
      download(response.data, response.headers['filename'] || 'BazaarCountSheet.pdf', 'application/pdf');
      dispatch({ type: WAIT_SUCCESS });
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: WAIT_FAIL });
    });
};

export const sendBazaarStock = (id, items, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  postRequest({ items }, undefined, `/${id}/send-stock`, token, endpoints.imsAdmin.bazaars)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS });
      notification.success({ message: response.data.message });
      if (response.data.failedStockUpdates?.length) {
        notification.warning({
          message: `Shopify sync failed for: ${response.data.failedStockUpdates.join(', ')}`,
        });
      }
      return getRequest(undefined, `/${id}`, token, endpoints.imsAdmin.bazaars);
    })
    .then((response) => {
      dispatch({ type: FETCH_RECORDS_SUCCESS, payload: response.data });
      navigate && navigate(`/ims/admin/bazaars/${id}`);
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: WAIT_FAIL });
    });
};

export const createBazaarCashier = (id, data) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  return postRequest(data, undefined, `/${id}/cashiers`, token, endpoints.imsAdmin.bazaars)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS });
      notification.success({ message: response.data.message });
      return response.data;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: WAIT_FAIL });
      throw err;
    });
};

export const completeBazaar = (id, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  postRequest({}, undefined, `/${id}/complete`, token, endpoints.imsAdmin.bazaars)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS });
      notification.success({ message: response.data.message });
      if (response.data.returnInbound?._id) {
        navigate && navigate('/ims/admin/inbounds');
      } else {
        navigate && navigate(`/ims/admin/bazaars/${id}`);
      }
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: WAIT_FAIL });
    });
};

export const updateBazaarCashier = (bazaarId, cashierId, data) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  return putRequest(data, undefined, `/${bazaarId}/cashiers/${cashierId}`, token, endpoints.imsAdmin.bazaars)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS });
      notification.success({ message: response.data.message });
      return response.data;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: WAIT_FAIL });
      throw err;
    });
};

export const deleteBazaarCashier = (bazaarId, cashierId) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  return delRequest(undefined, `/${bazaarId}/cashiers/${cashierId}`, token, endpoints.imsAdmin.bazaars)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS });
      notification.success({ message: response.data.message });
      return response.data;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: WAIT_FAIL });
      throw err;
    });
};

export const getBazaarPurchases = (id, data) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;
  return getRequest(data, `/${id}/purchases`, token, endpoints.imsAdmin.bazaars)
    .then((response) => {
      dispatch({ type: FETCH_RECORDS_SUCCESS, payload: { bazaarPurchases: response.data.purchases } });
      return response.data;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: FETCH_RECORDS_FAIL });
      throw err;
    });
};

export const getStockRecountTemplate = (data) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;
  return getRequest(data, undefined, token, endpoints.imsAdmin.stockRecount.template)
    .then((response) => {
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: { stockRecountProducts: response.data.products },
      });
      return response.data.products;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: FETCH_RECORDS_FAIL });
      throw err;
    });
};

export const getStockRecounts = (data) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;
  return getRequest(data, undefined, token, endpoints.imsAdmin.stockRecount.root)
    .then((response) => {
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: { stockRecounts: response.data.stockRecounts },
      });
      return response.data.stockRecounts;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: FETCH_RECORDS_FAIL });
      throw err;
    });
};

export const submitStockRecount = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  notification.info({ message: 'Starting stock recount...' });
  return postRequest(data, undefined, undefined, token, endpoints.imsAdmin.stockRecount.root)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS });
      const recountTaskId = response.data?.recountTaskId;
      notification.success({ message: response.data?.message || 'Stock recount started.' });
      if (navigate && recountTaskId) {
        sessionStorage.setItem('lastRecountTaskId', recountTaskId);
        navigate(`/ims/admin/stock-recount/progress/${recountTaskId}`);
      }
      return response.data;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: WAIT_FAIL });
      throw err;
    });
};

export const getStockRecountTask = (taskId) => (dispatch, useState) => {
  const token = useState().auth?.token;
  return getRequest(undefined, `/${taskId}`, token, endpoints.imsAdmin.stockRecount.root)
    .then((response) => response.data.task)
    .catch((err) => {
      throw err;
    });
};